/**
 * Multi-language keywords for Auto-DM validation
 * Supports 16 languages: English, Spanish, Arabic, French, German, Portuguese, Italian, 
 * Dutch, Turkish, Polish, Russian, Ukrainian, Japanese, Chinese, Korean, Hindi
 */
export const autoDmKeywords = [
  // English
  'dm', 'dms', 'message', 'messages', 'inbox', 'send', 'sending', 'sent',
  'comment', 'comments', 'reply', 'replies', 'retweet', 'retweets', 'rt',
  'direct', 'private', 'msg', 'text', 'write', 'contact', 'reach',

  // Spanish
  'mensaje', 'mensajes', 'enviar', 'envío', 'envio', 'enviare', 'enviaré',
  'mandar', 'mando', 'manda', 'responder', 'respuesta', 'respuestas',
  'comentar', 'comenta', 'comentario', 'comentarios', 'retuitear', 'retweet',
  'escribir', 'escribe', 'contactar', 'directo', 'privado', 'bandeja',

  // Arabic
  'رسالة', 'رسائل', 'ارسال', 'ارسل', 'إرسال', 'سأرسل', 'بعث', 'ابعث',
  'رد', 'ردود', 'تعليق', 'تعليقات', 'اعادة', 'تغريد', 'ريتويت',
  'مباشر', 'خاص', 'صندوق', 'اكتب', 'كتابة', 'تواصل',

  // French
  'message', 'messages', 'envoyer', 'envoi', 'envoie', 'enverrai', "j'enverrai",
  'répondre', 'repondre', 'réponse', 'reponse', 'réponses', 'reponses',
  'commenter', 'commentaire', 'commentaires', 'retweeter', 'retweet',
  'écrire', 'ecrire', 'écris', 'ecris', 'direct', 'privé', 'prive',
  'boîte', 'boite', 'contacter', 'mp',

  // German
  'nachricht', 'nachrichten', 'senden', 'sende', 'schicken', 'schicke',
  'antworten', 'antworte', 'antwort', 'antworten', 'kommentieren',
  'kommentar', 'kommentare', 'retweeten', 'retweet', 'direktnachricht',
  'schreiben', 'schreibe', 'privat', 'kontaktieren', 'kontakt', 'dm',

  // Portuguese
  'mensagem', 'mensagens', 'enviar', 'envio', 'enviarei', 'mandar', 'mando',
  'responder', 'respondo', 'resposta', 'respostas', 'comentar', 'comento',
  'comentário', 'comentario', 'comentários', 'comentarios', 'retweetar',
  'retuitar', 'retweet', 'escrever', 'escrevo', 'direto', 'privado',
  'caixa', 'contatar', 'contactar',

  // Italian
  'messaggio', 'messaggi', 'inviare', 'invio', 'invierò', 'inviero',
  'mandare', 'mando', 'rispondere', 'rispondo', 'risposta', 'risposte',
  'commentare', 'commento', 'commenti', 'ritwittare', 'retweet',
  'scrivere', 'scrivo', 'diretto', 'privato', 'casella', 'contattare',

  // Dutch
  'bericht', 'berichten', 'versturen', 'verstuur', 'sturen', 'stuur',
  'verzenden', 'antwoorden', 'antwoord', 'antwoorden', 'reageren', 'reageer',
  'reactie', 'reacties', 'retweeten', 'retweet', 'schrijven', 'schrijf',
  'direct', 'privé', 'prive', 'inbox', 'contacteren', 'contact', 'dm',

  // Turkish
  'mesaj', 'mesajlar', 'göndermek', 'gönder', 'gönderme', 'gonder',
  'göndereceğim', 'gondereceğim', 'gönderecegim', 'gonderecegim',
  'cevap', 'cevaplar', 'yanıt', 'yanit', 'yanıtlar', 'yanitlar',
  'yorum', 'yorumlar', 'retweetle', 'retweet', 'yazmak', 'yaz',
  'direkt', 'özel', 'ozel', 'gelen kutusu', 'iletişim', 'iletisim',

  // Polish
  'wiadomość', 'wiadomosc', 'wiadomości', 'wiadomosci', 'wysłać', 'wyslac',
  'wyślij', 'wyslij', 'wysyłam', 'wysylam', 'wyślę', 'wysle',
  'odpowiedź', 'odpowiedz', 'odpowiedzi', 'odpowiedzieć', 'odpowiedziec',
  'komentarz', 'komentarze', 'komentować', 'komentowac', 'retweetować',
  'retweetowac', 'retweet', 'napisać', 'napisac', 'pisać', 'pisac',
  'bezpośredni', 'bezposredni', 'prywatny', 'skrzynka', 'kontakt',

  // Russian
  'сообщение', 'сообщения', 'отправить', 'отправлю', 'отправляю', 'послать',
  'ответ', 'ответы', 'ответить', 'отвечу', 'комментарий', 'комментарии',
  'комментировать', 'ретвит', 'ретвитнуть', 'написать', 'пишу', 'напишу',
  'прямое', 'личное', 'директ', 'inbox', 'связаться', 'контакт', 'дм',

  // Ukrainian
  'повідомлення', 'відправити', 'відправлю', 'надіслати', 'надішлю',
  'відповідь', 'відповіді', 'відповісти', 'відповім', 'коментар', 'коментарі',
  'коментувати', 'прокоментувати', 'ретвіт', 'ретвітнути', 'написати', 'напишу',
  'пишу', 'пряме', 'особисте', 'приватне', 'директ', "зв'язатися", 'контакт',
  'інбокс', 'скринька', 'дм',

  // Japanese
  'メッセージ', 'メッセ', '送信', '送る', '送ります', '送って', '送った',
  '返信', '返事', '返す', 'コメント', 'コメする', 'リツイート', 'ＲＴ',
  '書く', '書いて', 'ダイレクト', 'ダイレクトメッセージ', 'ＤＭ', '連絡',

  // Chinese (Simplified)
  '消息', '信息', '发送', '发', '寄', '回复', '回', '评论', '评', '转发', '转推',
  '写', '私信', '私聊', '留言', '联系', '联络', '收件箱', 'dm',

  // Korean
  '메시지', '메세지', '보내기', '보낼게', '보내요', '보냄', '답장', '답변',
  '댓글', '리트윗', 'RT', '쓰기', '작성', '다이렉트', '디엠', 'DM',
  '개인', '연락', '받은편지함', '쪽지',

  // Hindi
  'संदेश', 'संदेशों', 'भेजना', 'भेजूंगा', 'भेजेंगे', 'भेजो', 'भेज',
  'जवाब', 'जवाब देना', 'उत्तर', 'टिप्पणी', 'टिप्पणियाँ', 'रीट्वीट',
  'लिखना', 'लिखो', 'डायरेक्ट', 'निजी', 'इनबॉक्स', 'संपर्क', 'डीएम',
];

/**
 * Creates a regex pattern for validating Auto DM keywords
 * @returns RegExp for matching Auto DM keywords in any supported language
 */
export const createAutoDmKeywordRegex = (): RegExp => {
  // Escape special regex characters (.*+?^${}()|[]\) in each keyword to treat them as literal strings
  const escapedKeywords = autoDmKeywords.map(keyword =>
    keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );

  return new RegExp(escapedKeywords.join('|'), 'gi');
};

/**
 * Validates if tweet text contains Auto DM keywords
 * @param text - The tweet text to validate
 * @returns true if text contains at least one Auto DM keyword, false otherwise
 */
export const validateAutoDmKeywords = (text: string): boolean => {
  const regex = createAutoDmKeywordRegex();
  return regex.test(text);
};
